document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.getElementById('hamburgerToggle');
    const closeBtn = document.getElementById('mobileMenuClose');
    const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
    const menuOverlay = document.getElementById('mobileMenuOverlay');
    const header = document.querySelector('.site-header');

    function openMobileMenu() {
        if (!hamburger || !mobileMenuDrawer) return;

        hamburger.classList.add('active');
        hamburger.setAttribute('aria-expanded', 'true');
        mobileMenuDrawer.classList.add('active');
        if (menuOverlay) menuOverlay.classList.add('active');
        document.body.classList.add('mobile-menu-open');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        if (!hamburger || !mobileMenuDrawer) return;

        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenuDrawer.classList.remove('active');
        if (menuOverlay) menuOverlay.classList.remove('active');
        document.body.classList.remove('mobile-menu-open');
        document.body.style.overflow = '';
    }

    if (hamburger && mobileMenuDrawer) {
        hamburger.addEventListener('click', function (event) {
            event.preventDefault();

            if (mobileMenuDrawer.classList.contains('active')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);

    document.querySelectorAll('.mobile-nav-menu .menu-item-has-children > a').forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            this.parentElement.classList.toggle('active');
        });
    });

    if (header) {
        const handleScroll = () => {
            header.classList.toggle('is-sticky', window.scrollY > 200);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
    }

    window.addEventListener('resize', function () {
        if (window.innerWidth > 991) {
            closeMobileMenu();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeMobileMenu();
        }
    });
});
